import { Decimal } from "decimal.js";
export default {
  install (Vue, options){
    Vue.prototype.$decimalToFixed = function (num, priceDecimalPlace, round_half=Decimal.ROUND_DOWN) {
      if(priceDecimalPlace || priceDecimalPlace == 0) return new Decimal(num).toFixed(priceDecimalPlace, round_half);
      else return new Decimal(num).toFixed();
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/decimalobj.js